<template>
  <NavPrimaryPart
    :navList="mainNavList"
    :accountActions="listAccountActions"
    :quizActions="listQuizActions"
    :isAccountPopupOpen="isAccountPopupOpen"
    :isQuizPopupOpen="isQuizPopupOpen"
    :isGlow="isGlow"
    :activeGroup="activeGroup"
    @toggle-account-popup="showUserPopup"
    @toggle-quiz-popup="showQuizPopup"
  />

  <NavSecondaryPart
    v-if="isOnlineAppointment"
    title="Онлайн-запись"
    :navList="onlineAppointmentNavList"
    :activeGroup="activeGroup"
  />
  <NavSecondaryPart
    v-if="isQuizPages"
    :title="quiz.name"
    :navList="quizPagesNavList"
    :activeGroup="activeGroup"
  />
</template>

<script lang="ts">
import {defineComponent} from "vue";
import NavPrimaryPart from "./components/NavPrimaryPart.vue";
import NavSecondaryPart from "./components/NavSecondaryPart.vue";

import homeIcon from "$images/icons/tabs/Name=Home, Size=16, Tone=Default.svg";
import folderIcon from "$images/icons/tabs/Name=Folder, Size=16, Tone=Default.svg";
import plugIcon from "$images/icons/tabs/Name=Plug, Size=16, Tone=Default.svg";
import requestsImg from "$images/icons/tabs/Name=Requests, Size=16, Tone=Default.svg";
import addIcon from "$images/icons/button/Name=Add, Size=16, Tone=Default.svg";
import moreIcon from "$images/icons/button/Name=More, Size=16, Tone=Default.svg";

import gridImg from "$images/icons/tabs/Name=Grid, Size=16, Tone=Default.svg";
import settingIcon from "$images/icons/tabs/Name=Settings, Size=16.svg";
import ABTestIcon from "$images/icons/tabs/Name=Ab-test, Size=16.svg";
import analyticsIcon from "$images/icons/tabs/Name=Analytics, Size=16.svg";
import doctorsImg from "$images/icons/tabs/Name=Врачи, Size=16, Tone=Default.svg";
import clinicIcon from "$images/icons/tabs/Name=Clinic, Size=16.svg";
import priceImg from "$images/icons/tabs/Name=Price, Size=16.svg";

import accountImg from "$images/icons/tabs/Name=User, Size=16, Tone=Default.svg";
import databaseImg from "$images/icons/tabs/Name=Database, Size=16, Tone=Default.svg";
import logoutImg from "$images/icons/button/Name=Logout, Size=16, Tone=Default.svg";
import {QuizListItem} from "@/page/quiz/typeQuiz";
import {createQuiz} from "@/page/quiz/editor/List/services";

export default defineComponent({
  name: "NavLayoutNew",
  components: {
    NavPrimaryPart,
    NavSecondaryPart
  },
  data() {
    return {
      isAccountPopupOpen: false,
      isQuizPopupOpen: false
    };
  },
  mounted() {
    document.addEventListener("click", this.closePopups);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closePopups);
  },
  methods: {
    closePopups() {
      this.isAccountPopupOpen = false;
      this.isQuizPopupOpen = false;
    },

    showUserPopup() {
      this.isAccountPopupOpen = !this.isAccountPopupOpen;
      this.isQuizPopupOpen = false;
    },

    showQuizPopup() {
      this.isQuizPopupOpen = !this.isQuizPopupOpen;
      this.isAccountPopupOpen = false;
    },

    exitFromAccount() {
      localStorage.clear();
      document.location.pathname = "/authorization";
    },

    accountHandler() {
      this.$router.push({path: "/user"});
    },

    tariffHandler() {
      this.$router.push({path: "/tariff"});
    }
  },
  computed: {
    activeGroup(): string {
      const deepest = this.$route.matched.at(-1);
      console.log(
        deepest,
        deepest?.meta?.navGroup,
        this.$route.meta.navGroup,
        deepest?.meta?.navGroup ?? this.$route.meta.navGroup ?? ""
      );
      return String(deepest?.meta?.navGroup ?? this.$route.meta.navGroup ?? "");
    },

    mainNavList(): ListActionItem[] {
      return [
        {
          value: "home",
          handler: () => this.$router.push("/home"),
          icon: homeIcon,
          text: "Главная"
        },
        {
          value: "quiz",
          handler: this.showQuizPopup,
          icon: folderIcon,
          text: "Проекты"
        },
        {
          value: "integration",
          handler: () => this.$router.push("/user/integration"),
          icon: plugIcon,
          text: "Интеграции"
        },
        {
          value: "settingApplication",
          handler: () => this.$router.push("/setting/application"),
          icon: requestsImg,
          text: "Заявки"
        }
      ];
    },

    onlineAppointmentNavList(): ListActionItem[] {
      return [
        {
          value: "setting",
          handler: () => this.$router.push("/setting"),
          icon: clinicIcon,
          text: "Клиника"
        },
        {
          value: "settingDoctors",
          handler: () => this.$router.push("/setting/doctors"),
          icon: doctorsImg,
          text: "Врачи"
        },
        {
          value: "settingServices",
          handler: () => this.$router.push("/setting/services"),
          icon: priceImg,
          text: "Цены"
        }
      ];
    },

    quizPagesNavList(): ListActionItem[] {
      return [
        {
          value: "landingPage",
          handler: () => {
            this.$router.push(`/quiz/setting/${this.quiz._id}/landingPage`);
            localStorage.removeItem("ABTest");
          },
          icon: gridImg,
          text: "Экраны"
        },
        {
          value: "configuration",
          handler: () =>
            this.$router.push(`/quiz/setting/${this.quiz._id}/configuration`),
          icon: settingIcon,
          text: "Настройки"
        },
        {
          value: "ABTest",
          handler: () => {
            this.$router.push(`/quiz/setting/${this.quiz._id}/ABTest`);
            localStorage.setItem("ABTest", "true");
          },
          icon: ABTestIcon,
          text: "AB-тест",
          disabled: this.quiz.ABTestBool ? false : true
        },
        {
          value: "analytics",
          handler: () =>
            this.$router.push(`/quiz/setting/${this.quiz._id}/analytics`),
          icon: analyticsIcon,
          text: "Аналитика"
        }
      ];
    },

    listAccountActions(): ListActionItem[] {
      return [
        {
          text: "Аккаунт",
          icon: accountImg,
          variant: "tab",
          handler: this.accountHandler
        },
        {
          text: "Тариф",
          icon: databaseImg,
          variant: "tab",
          handler: this.tariffHandler
        },
        {
          text: "Выйти",
          icon: logoutImg,
          variant: "button",
          handler: this.exitFromAccount
        }
      ];
    },

    listQuizActions(): ListActionItem[] {
      let quizActions: ListActionItem[] = [
        {
          text: "Квизы",
          icon: moreIcon,
          handler: () => {
            this.$router.push("/quiz");
          },
          disabled: false,
          variant: "header"
        }
      ];

      this.quizList.forEach((quiz) => {
        quizActions.push({
          text: quiz.name,
          icon: "transparent",
          variant: "tab",
          active: quiz._id === this.quiz._id,
          handler: () => {
            this.$router.push(`/quiz/setting/${quiz._id}/landingPage`);
          }
        });
      });

      return [
        ...quizActions,
        {
          text: "Создать квиз",
          icon: addIcon,
          handler: createQuiz,
          variant: "button"
        },
        {
          text: "Прочее",
          icon: "transparent",
          handler: () => {},
          variant: "header",
          disabled: true
        },
        {
          text: "Онлайн-запись",
          icon: "transparent",
          variant: "tab",
          handler: () => {
            this.$router.push("/setting");
          }
        }
      ];
    },

    isOnlineAppointment(): boolean {
      return ["setting", "settingServices", "settingDoctors"].includes(
        this.activeGroup
      );
    },

    isQuizPages(): boolean {
      return ["landingPage", "configuration", "ABTest", "analytics"].includes(
        this.activeGroup
      );
    },

    isGlow(): boolean {
      return (
        this.$route.meta.children === "AccountComponent" ||
        this.$route.meta.navGroup === "tariff"
      );
    },
    quizList(): QuizListItem[] {
      return this.$quizStore.getQuizList;
    },
    quiz() {
      return this.$quizStore.getQuiz;
    }
  },
  watch: {
    $route() {
      this.closePopups();
    }
  }
});
</script>
